import React from 'react'

const ShowErrorMsg = ({ errors, name }) => {
    return (
        <div>
            {errors && (
                <div className="text-red-500 text-sm my-1 ">
                    {errors?.[name]?.message}
                </div>
            )}
        </div>
    )
}

export default ShowErrorMsg